import { render, staticRenderFns } from "./ProdcutSupport.vue?vue&type=template&id=216807a2&scoped=true"
import script from "./ProdcutSupport.vue?vue&type=script&lang=ts"
export * from "./ProdcutSupport.vue?vue&type=script&lang=ts"
import style0 from "./ProdcutSupport.vue?vue&type=style&index=0&id=216807a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216807a2",
  null
  
)

export default component.exports